"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    WebSocketManager: ()=>WebSocketManager
});
class WebSocketManager {
    static instance;
    connections = new Map();
    listeners = new Map();
    constructor(){}
    static getInstance() {
        if (!this.instance) this.instance = new WebSocketManager();
        return this.instance;
    }
    getConnection(key) {
        return this.connections.get(key);
    }
    addMessageListener(key, listener) {
        if (!this.listeners.has(key)) this.listeners.set(key, new Set());
        this.listeners.get(key).add(listener);
    }
    removeMessageListener(key, listener) {
        this.listeners.get(key)?.delete(listener);
    }
    createConnection(key, url) {
        if (!this.connections.has(key)) {
            const ws = new WebSocket(url);
            ws.onmessage = (event)=>{
                this.listeners.get(key)?.forEach((listener)=>{
                    try {
                        const data = JSON.parse(event.data);
                        listener(data);
                    } catch  {}
                });
            };
            this.connections.set(key, ws);
            return ws;
        }
        return this.connections.get(key);
    }
    closeConnection(key) {
        const ws = this.connections.get(key);
        if (ws) {
            ws.close();
            this.connections.delete(key);
            this.listeners.delete(key);
        }
    }
}
exports.WebSocketManager = __webpack_exports__.WebSocketManager;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "WebSocketManager"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
